import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import MicrosoftDefenderConfigListing from './MicrosoftDefenderConfigListing'
import MicrosoftDefenderCredentialsForm from './MicrosoftDefenderCredentialsForm'

export default function MicrosoftDefenderPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={MicrosoftDefenderCredentialsForm}
            PullConfigListingView={MicrosoftDefenderConfigListing}
        />
    )
}
